import { Button, Div, Icon } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useUser } from "../../api/auth/AuthSelector";
import { useState } from "react";
import EditProfile from "./EditProfile";
import ProfileInfo from "./ProfileInfo";

export default function ProfileScreen({ navigation }: MainStackScreenProps<"profile">) {
  const user = useUser();
  const [isEditing, setEditing] = useState(false);
  const toggleEditing = () => setEditing(!isEditing);
  return (
    <ScreenLayout
      header={{
        center: "ACCOUNT",
        left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} />,
      }}
    >
      {user ? (
        <Div classNames={["flex1"]}>
          <Button
            classNames={["ml-{auto}", "btn", isEditing ? "btnDanger" : "btnOutlinePrimary"]}
            title={isEditing ? "Cancel" : "Edit"}
            right={{ name: isEditing ? "cancel" : "edit" }}
            onPress={toggleEditing}
          />
          <Div classNames={["flex1", "mt-{24}"]}>
            {isEditing ? <EditProfile player={user} onEditFinished={toggleEditing} /> : <ProfileInfo player={user} />}
          </Div>
        </Div>
      ) : null}
    </ScreenLayout>
  );
}
